import React from 'react';
import EmptyCode from "../../resources/icon/empty-code.png";

function NoSelected({title, height, className}) {
    return (
        <div className={`${className ?? 'w-full'}`} style={{height:height ? height+'px':'100%'}}>
            <div className="w-full h-full bg-[#fafafa] item-center   b-gray">
                <img src={EmptyCode} className={`m-auto `} style={{marginTop:height?(height/2 - 100)+'px':'50%'}} />
                <div>{title}</div>
            </div>
        </div>
    );
}

export default NoSelected;